import { render, staticRenderFns } from "./ApkVersionCreate.vue?vue&type=template&id=6412e140&scoped=true&"
import script from "./ApkVersionCreate.vue?vue&type=script&lang=js&"
export * from "./ApkVersionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6412e140",
  null
  
)

export default component.exports